import React, { useState } from 'react';
import AnimatedIcon from '../components/AnimatedIcon';
import { useAuth } from '../context/AuthContext';

/** Вход в среду. Аккаунты выдаёт преподаватель — саморегистрации нет. */
function LoginPage() {
  const { signIn } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setBusy(true);
    setError(null);
    try {
      await signIn(username.trim(), password);
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось войти. Попробуйте ещё раз.');
      setBusy(false);
    }
  };

  const field = {
    width: '100%', padding: '10px 12px', fontSize: 14, marginBottom: 12,
    border: '2px solid var(--mipt-border)', borderRadius: 8, outline: 'none',
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--mipt-bg)' }}>
      <form onSubmit={handleSubmit} style={{ width: 380, maxWidth: '92vw', background: 'white', padding: 32,
        borderRadius: 12, boxShadow: 'var(--mipt-shadow)', border: '1px solid var(--mipt-border)' }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <AnimatedIcon name="planet" size={84} />
          <h1 style={{ fontSize: 24, fontWeight: 700, margin: '8px 0 2px' }}>
            COMB-AI<sup style={{ fontSize: '0.55em' }}>n</sup>
          </h1>
          <div style={{ fontSize: 13, color: 'var(--mipt-text-secondary)' }}>
            Формальная верификация и ИИ-инструменты математика · ОКТЧ, ФПМИ МФТИ
          </div>
        </div>

        <input style={field} value={username} onChange={(e) => setUsername(e.target.value)}
               placeholder="Логин" autoComplete="username" autoFocus />
        <input style={field} type="password" value={password} onChange={(e) => setPassword(e.target.value)}
               placeholder="Пароль" autoComplete="current-password" />

        {error && (
          <div style={{ padding: '8px 12px', background: '#fef2f2', border: '1px solid #fecaca',
            borderRadius: 6, color: '#991b1b', fontSize: 13, marginBottom: 12 }}>{error}</div>
        )}

        <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={busy}>
          {busy ? 'Проверяю...' : 'Войти'}
        </button>
        <div style={{ fontSize: 12, color: 'var(--mipt-text-secondary)', marginTop: 12, textAlign: 'center' }}>
          Логин и пароль выдаёт преподаватель курса. Списать не выйдет: среда запоминает не ответы, а путь к ним.
        </div>
      </form>
    </div>
  );
}

export default LoginPage;
